
export const devotionsData = [
  {
    id: 1,
    date: 'MARCH 15, 2025',
    title: 'Finding Peace in the Storm',
    excerpt: 'When life\'s challenges threaten to overwhelm us, we can find refuge in God\'s unchanging presence. He is our anchor in every storm, our peace in every trial.',
    content: 'Full devotional content here...'
  },
  {
    id: 2,
    date: 'MARCH 8, 2025',
    title: 'The Power of Persistent Prayer',
    excerpt: 'God invites us to come boldly before His throne with our requests. Through persistent prayer, we align our hearts with His will and experience His faithfulness.',
    content: 'Full devotional content here...'
  },
  {
    id: 3,
    date: 'MARCH 1, 2025',
    title: 'Walking in God\'s Light',
    excerpt: 'As children of light, we are called to reflect Christ\'s love in everything we do. Let your life be a testimony of His grace and transforming power.',
    content: 'Full devotional content here...'
  }
];
